
import { Component, Vue, Prop } from 'vue-property-decorator'
import FetchWrapper from '@/classes/fetchWrapper'

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

const CreateCallProps = Vue.extend({
  props: {
    canCancel: Boolean,
    close: Boolean
  }
})

@Component
export default class CreateVideoModal extends CreateCallProps {
  data () {
    return {
      isLoading: false,
      formDataValid: false,
      ytbId: '',
      ytbIdValid: false,
      player: null,
      iframeBuilt: false
    }
  }

  get isComponentModalActive () {
    return this.close
  }

  created () {
    this.$multiwatch(['ytbId'], function () {
      this.formDataValid = this.$refs.form.checkValidity()
    })
  }

  previewVideo () {
    if (this.iframeBuilt) {
      this.player.loadVideoById(this.ytbId)
    } else {
      this.buildYoutubeIframe()
    }
  }

  buildYoutubeIframe () {
    window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady.bind()
    // 2. This code loads the IFrame Player API code asynchronously.
    var tag = document.createElement('script')

    tag.src = 'https://www.youtube.com/iframe_api'
    var firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    this.iframeBuilt = true
  }

  // 3. This function creates an <iframe> (and YouTube player)
  //    after the API code downloads.
  onYouTubeIframeAPIReady () {
    this.player = new window.YT.Player('playerModal', {
      height: '100%',
      width: '100%',
      // videoId: 'M7lc1UVf-VE',
      videoId: this.ytbId,
      playerVars: {
        playsinline: 1,
        controls: 1,
        disablekb: 1,
        loop: 0,
        hl: 'en-us',
        enablejsapi: 0,
        iv_load_policy: 3,
        origin: process.env.VUE_APP_SERVERURL,
        rel: 0
      }
    })
  }

  async createVideo () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/createVideo/${this.ytbId}`))
      this.$buefy.dialog.confirm({
        title: 'Success',
        message: 'Video created sucessfully.',
        onConfirm: async () => {
          this.$emit('created')
        },
        canCancel: false
      })
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: resp.error,
        canCancel: false
      })
    }
  }
}
